<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    const token = this.$route.params.token;
    this.$store.dispatch('auth/emailLogin', {
      token,
      redirectUrl: '/effort',
      router: this.$router,
    });
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/EmailLogin.vue